/**
 * Datepicker modules
 */
export * from './datepicker';



//////////////////
// WEBPACK FOOTER
// ./node_modules/@syncfusion/ej2-calendars/src/datepicker/index.js
// module id = 1907
// module chunks = 0